<template>
    <div class="container-wide login-box">
        <div class="login-title">{{getLabel('RESET_PWD')}}</div>
        <p class="login-tip">{{getLabel('RESET_GUIDE')}}</p>
        <a-form
            @submit="handleSubmit"
            :form="form"
            class='login-form'>
            <a-form-item>
                <a-input
                    v-decorator="['password', {rules: [{ required: true, message: getLabel('RESET_NEW_PWD') }]}]"
                    :placeholder="getLabel('RESET_NEW_PWD')"
                    size="large"
                    type='password'
                    autocomplete="off"
                />
            </a-form-item>
            <a-form-item>
                <a-input
                    v-decorator="['password_confirm', {rules: [{ required: true, message: getLabel('RESET_NEW_PWD_AGAIN') }]}]"
                    :placeholder="getLabel('RESET_NEW_PWD_AGAIN')"
                    size="large"
                    type='password'
                    autocomplete="off"
                />
            </a-form-item>
            <a-form-item style="padding-top: 30px;">
                <a-button type='primary' htmlType='submit' class='login-form-button' size="large" block>
                    {{getLabel('RESET_SAVE')}}
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Language from '../util/language';

	export default {
		data () {
			return {
				form: this.$form.createForm(this)
			}
		},
		computed: {
			...mapState({
				language: state => state.main.language
			})
		},
		methods: {
			handleSubmit: function (e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						const {password, password_confirm} = values;
            // 添加的密码校验逻辑
            const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@!%*?&#])[A-Za-z\d$@!%*?&#]{12,}$/;
            if (!passwordPattern.test(password)) {
              this.$store.commit('main/openMessage', {
                type: 'error',
                message: this.getLabel('RESET_PASSWORD_INVALID')
              }, { root: true });
              return;
            }
						if (password !== password_confirm) {
							this.$store.commit('main/openMessage', {
								type: 'error',
								message: this.getLabel('RESET_NOT_EQUAL')
							}, { root: true });
                        } else {
							this.$store.dispatch('reset/resetPassword', { password });
                        }
					}
				})
			},
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			}
		}
	}
</script>

<style lang="less" scoped>
    @import "../assets/less/login";
</style>